import { h } from '@atomify/jsx';
import { useTranslate } from '@utilities/hooks';

interface WishlistProjectHeadingInterface {
    title: string;
    statusLabel?: string | Text;
    status?: string;
    total?: Text | string | null;
    classes?: string;
}

const WishlistProjectHeading = (data: WishlistProjectHeadingInterface) => (
    <div class={`c-project-heading ${data.classes ? data.classes : ''}`}>
        <div class="project-heading__count u-body-normal u-text--bold">
            {data.total ? data.total : 0}
        </div>
        <div class="project-heading__details">
            <h3 class="u-subtitle-3 u-subtitle-2--md">
                {useTranslate('Wishlist-Favorites')} {data.title}
            </h3>
            <span class={data.status ? `u-color--${data.status}` : ''}>{data.statusLabel}</span>
        </div>
    </div>
);

export { WishlistProjectHeading };
